"use strict";
/**
 * Created by Astghik.Hakobyan on 1/17/2018.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var HierarchicalMetaCategoryId = /** @class */ (function () {
    function HierarchicalMetaCategoryId(systemName, isRoot, children) {
        this.systemName = systemName;
        this.isRoot = isRoot;
        this.children = children;
    }
    HierarchicalMetaCategoryId.prototype.getSystemName = function () {
        return this.systemName;
    };
    HierarchicalMetaCategoryId.prototype.getIsRoot = function () {
        return this.isRoot;
    };
    HierarchicalMetaCategoryId.prototype.getChildren = function () {
        return this.children;
    };
    return HierarchicalMetaCategoryId;
}());
exports.HierarchicalMetaCategoryId = HierarchicalMetaCategoryId;
//# sourceMappingURL=hierarchical-meta-category-id.js.map